export const CREATE_ORDER = "CREATE_ORDER";
export const SINGLE_ORDER = "SINGLE_ORDER";
export const ORDER_LIST = "ORDER_LIST";
